var _this = this;
import * as tslib_1 from "tslib";
import { onEnterPressedSearchInput } from '../actions/internalActions';
import { onSearchTextChanged, startSearch, suggestionSelected } from '../actions/publicActions';
import { defaultSearchStore, getStore } from '../store/store';
import { lazyIsSearchBoxEmpty, lazySetIsFocusInSearchInput } from 'owa-search';
import { orchestrator } from 'satcheljs';
/**
 * When "Enter" is pressed in SearchInput, handle it.
 *
 * 1. If there's a selectedSuggestionIndex (i.e. user is navigating
 *    SuggestionsContextMenu with up/down arrow keys), dispatch a suggestionSelected
 *    action so consuming client can handle appropriately based on suggestion.
 * 2. If there's no selectedSuggestionIndex, just submit a search (if search
 *    box isn't empty).
 */
export default orchestrator(onEnterPressedSearchInput, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var selectedSuggestionIndex, isSearchBoxEmpty;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                selectedSuggestionIndex = actionMessage.selectedSuggestionIndex;
                return [4 /*yield*/, lazyIsSearchBoxEmpty.import()];
            case 1:
                isSearchBoxEmpty = _a.sent();
                if (selectedSuggestionIndex !== defaultSearchStore.selectedSuggestionIndex) {
                    // Dispatch action to let consumer know a suggestion was selected.
                    suggestionSelected(getStore().currentSuggestions.Suggestions[selectedSuggestionIndex], 'keyboard');
                    // Remove focus from search input so suggestions context menu is hidden.
                    lazySetIsFocusInSearchInput.importAndExecute(false /* isFocusInSearchInput */);
                }
                else if (!isSearchBoxEmpty()) {
                    // Kick off search.
                    startSearch('Keyboard', true /* explicitSearch */);
                    // Remove focus from search input so suggestions context menu is hidden.
                    lazySetIsFocusInSearchInput.importAndExecute(false /* isFocusInSearchInput */);
                }
                /**
                 * This is specific to the case where the user is arrowing up/down the
                 * SuggestionsContextMenu and hits "Enter" on a pill suggestion. We want
                 * to clear searchText, searchTextForSuggestion, and reset suggestions.
                 */
                if (!getStore().searchText) {
                    onSearchTextChanged('');
                }
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=onEnterPressedSearchInputOrchestrator.js.map